import { render, staticRenderFns } from "./TinyDeleteConfirm.vue?vue&type=template&id=54b3e948&scoped=true&"
import script from "./TinyDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./TinyDeleteConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TinyDeleteConfirm.vue?vue&type=style&index=0&id=54b3e948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3e948",
  null
  
)

component.options.__file = "TinyDeleteConfirm.vue"
export default component.exports